"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Stop editing on escape.
 */
exports.default = function (event, _ref) {
    var getProps = _ref.getProps;

    var _getProps = getProps(),
        stopEditing = _getProps.stopEditing;

    if (!stopEditing) return;

    event.preventDefault();
    // TODO Check all devices to see if this was really necessary
    // this.editor.blur();
    stopEditing();
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/milanoteShortcuts/onEscape.js
// module id = 1741
// module chunks = 0